export const MEGABYTES_TO_BYTES = 1024 * 1024;

export const MAX_IMAGE_SIZE_IN_BYTES = 10 * MEGABYTES_TO_BYTES; // 10 Megabytes
export const MAX_AVATAR_SIZE_IN_BYTES = 3 * MEGABYTES_TO_BYTES; // 3 Megabytes
export const MAX_FILE_SIZE_IN_MEGABYTES = 100;
export const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MEGABYTES * MEGABYTES_TO_BYTES;
export const MIN_FILE_SIZE_IN_BYTES = 1;

export const SUPPORTED_IMAGE_MIME_TYPES = ['image/jpg', 'image/png', 'image/jpeg'];
export const SUPPORTED_DOCUMENT_MIME_TYPES = ['application/pdf', 'application/msword', 'text/plain'];
